const getCurrentLangCode = () => localStorage.getItem('lang');

export { getCurrentLangCode };
